import { DialogComponent } from '@syncfusion/ej2-react-popups'
import { FC, useEffect, useState } from 'react'
import { ColumnDirective, ColumnsDirective, Filter, GridComponent, Inject, RowSelectingEventArgs } from '@syncfusion/ej2-react-grids'
import { ButtonComponent } from '@syncfusion/ej2-react-buttons'
import { useOidcAccessToken } from '@axa-fr/react-oidc'
import { protectedResources } from '../../../global/config.tsx'
import { fetchDataFromApi } from '../../../services/fetchDataFromApi.tsx'
import styles from './dlgAddressSelector.module.scss'
import { INwDocentDto } from '../../../types/INwDocentDto.tsx'

interface IDlgAddressSelectorProps {
  visible: boolean | undefined
  onClose: (lecturerRecord: INwDocentDto | null) => void
  onCancel: () => void
}

const DlgAddressSelector: FC<IDlgAddressSelectorProps> = ({ visible, onClose, onCancel }) => {
  const { accessToken } = useOidcAccessToken()
  const [instructors, setInstructors] = useState<INwDocentDto[]>([])
  const [isButtonDisabled, setIsButtonDisabled] = useState(true)

  let gridInstance: GridComponent | null

  useEffect(() => {
    if (accessToken) {
      const url = protectedResources.apiList.readInstructors
      fetchDataFromApi(url, accessToken, 'GET', 'json').then((response) => {
        if (response.status === 200) {
          setInstructors(response.data)
        }
      })
    }
  }, [accessToken])

  // Selektiere contactId an Parent Component übermitteln
  const handleConfirmSelection = () => {
    if (gridInstance && gridInstance?.getSelectedRecords()[0]) {
      const selectedRecord = gridInstance?.getSelectedRecords()[0] as INwDocentDto
      if (selectedRecord) {
        onClose(selectedRecord)
      }
    }
  }

  const footerTemplate = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <ButtonComponent type={'button'} content={'Abbrechen'} onClick={onCancel} />
        <ButtonComponent type={'button'} isPrimary content={'Übernehmen'} disabled={isButtonDisabled} onClick={handleConfirmSelection} />
      </div>
    )
  }

  const headerTemplateCbx = () => {
    return <></>
  }

  // Nur eine Reihe selektierbar, type: 'Single' reicht nicht
  const onRowSelecting = (args: RowSelectingEventArgs) => {
    if (args.target) {
      gridInstance?.clearSelection()
      setIsButtonDisabled(false)
    }
  }

  const onRowDeselecting = () => {
    setIsButtonDisabled(true)
  }

  return (
    <DialogComponent visible={visible} width={'60%'} height={'80%'} header={'Dozent wählen'} footerTemplate={footerTemplate} isModal={true} showCloseIcon={false} closeOnEscape={false}>
      <GridComponent className={styles.grid} ref={(g) => (gridInstance = g)} rowSelecting={onRowSelecting} rowDeselecting={onRowDeselecting} dataSource={instructors} height={'100%'} selectionSettings={{ mode: 'Row', type: 'Single' }} filterSettings={{ type: 'FilterBar' }} allowFiltering={true}>
        <ColumnsDirective>
          <ColumnDirective type="checkbox" width="50" headerTemplate={headerTemplateCbx} />
          <ColumnDirective field="contactId" headerText={'ID'} width="100" />
          <ColumnDirective field="fullName" headerText={'Name'} />
        </ColumnsDirective>
        <Inject services={[Filter]} />
      </GridComponent>
    </DialogComponent>
  )
}

export default DlgAddressSelector
